import { render, staticRenderFns } from "./checkout-cart-totals-row.vue?vue&type=template&id=12fc7bf7&scoped=true"
import script from "./checkout-cart-totals-row.vue?vue&type=script&lang=js"
export * from "./checkout-cart-totals-row.vue?vue&type=script&lang=js"
import style0 from "./checkout-cart-totals-row.vue?vue&type=style&index=0&id=12fc7bf7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc7bf7",
  null
  
)

export default component.exports